import React from "react"
import classnames from "classnames"
import ErrorIcon from "../assets/icons/exclamation-triangle-solid.svg"
import SuccessIcon from "../assets/icons/heart.svg"
import { motion } from "framer-motion"

export function ErrorAlert({ className, children }) {
  return (
    <motion.div
      initial={{ x: -30, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: -30, opacity: 0 }}
      layout
      className={classnames(
        "bg-red-300 p-2 text-body-14 lg:text-base text-red-900 flex items-center",
        className
      )}
    >
      <ErrorIcon className="w-4 h-4 mr-4" />
      {children}
    </motion.div>
  )
}

export function SuccessAlert({ className, children }) {
  return (
    <motion.div
      initial={{ x: -30, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: -30, opacity: 0 }}
      layout
      className={classnames(
        "bg-green-300 p-2 text-body-14 lg:text-base text-green-900 flex items-center",
        className
      )}
    >
      <SuccessIcon className="w-4 h-4 mr-4" />
      {children}
    </motion.div>
  )
}
